<template>
    <div class="replenish-detail clearfix">
        <compWrapper title="基本信息" theme="primary">
            <Col offset="6" span="12">
            <compFormQuery :col="1" v-if="type == 'query'" :labelWidth="140" class="margin-15" :formdata="getBase" :data="formData"></compFormQuery>
            <compFormEdit :col="1" v-else :labelWidth="140" ref="validForm" class="margin-15" v-model="formData" :formdata="getBase"></compFormEdit>
            </Col>
            <!-- <div v-if="type != 'query'" slot="footer">
                <Button class="margin-right-15" type="primary" @click="submit">确定</Button>
                <Button @click="cancel">取消</Button>
            </div> -->
        </compWrapper>
        <compWrapper v-if="type == 'query'" title="操作历史" theme="gray">
            <compLog :data="logList" :columns="logcolumns"></compLog>
        </compWrapper>
        <div class="button-container pull-right">
            <Button v-if="type != 'query'" class="margin-right-15" type="primary" @click="submit">确定</Button>
            <Button @click="cancel">取消</Button>
        </div>
        <Spin fix v-if="loading"></Spin>
    </div>
</template>

<script>
import {
    HttpGetReplenishDetail,
    HttpSysOpLog,
    HttpSaveReplenishDetail,
    HttpGetDetailByProductId
} from "@/service/products/replenish";
export default {
    props: ['activeid', 'querytype'],
    components: {
        compWrapper: () => import("@components/templates/wrapper"),
		compFormQuery: () => import("@components/templates/formquery"),
        compFormEdit: () => import("@components/templates/formedit"),
        compLog: () => import("@components/templates/log"),
    },
    data () {
        return {
            id: this.activeid || this.$route.query.id,
            type: this.querytype || this.$route.params.type,
            formData: {
                orgId: global.SYSID,
                productId: 0,
                reProductId: 0,
            },
            logList: [],
            loading: false,
            quantity: null,
            reLineId: 0,
        }
    },
    async created () {
        if (this.type != 'add') {
            this.loading = true;
            await this.getDetail();
            if (this.type == 'query') {
                await this.getLog();
            }
            this.loading = false;
        }
    },
    computed: {
        getBase () {
            let isQuery = this.type == 'query';
            return [
                {
                    label: "ERP SKU",
                    key: "erpSku",
                    tag: "div",
                    children: (h) => {
                        return h('compErpSkuInput', {
                            props: {
                                value: this.formData.erpSku,
                                showread: "showyes"
                            },
                            on: {
                                'on-data': (row) => {
                                    this.formData.lineId = row.lineId;
                                    this.formData.productId = row.id;
                                    this.formData.erpSku = row.erpSku;
                                },
                            }
                        })
                    },
                    render: (h) => {
                        return this.formData.erpSku;
                    },
                    query: isQuery,
                },
                {
                    label: "补货ERP SKU",
                    key: "reErpSku",
                    tag: "div",
                    children: (h) => {
                        return h('compErpSkuInput', {
                            props: {
                                value: this.formData.reErpSku,
                                showread: "showyes"
                            },
                            on: {
                                'on-data': (row) => {
                                    this.reLineId = row.lineId;
                                    this.formData.reProductId = row.id;
                                    this.formData.reErpSku = row.erpSku;
                                },
                            }
                        })
                    },
                    render: (h) => {
                        return this.formData.reErpSku;
                    },
                    query: isQuery
                },
                {
                    label: "一个该ERP SKU等于",
                    key: "quantity",
                    tag: "div",
                    query: isQuery,
                    render: (h) => {
                        return (
                            <div>{this.formData.quantity}<span style="font-weight: normal; margin-left: 5px;">个补货规格ERP SKU</span></div>
                        );
                    },
                    children: (h) => {
                        let value = this.quantity
                        
                        return h('div', {
                            style: {
                                "display": "flex",
                            }
                        }, [
                            h('vInputNumber', {
                                props: {
                                    value: value,
                                    precision: 4
                                },
                                style: {
                                    "flex": "1",
                                    "margin-right": "15px"
                                },
                                on: {
                                    "on-change": (val) => {
                                        this.formData.quantity = val;
                                    }
                                }
                            }),
                            h('span', {}, "个补货规格ERP SKU")
                        ]);
                        // return <div slot="append">个补货规格ERP SKU</div>
                    },
                    // style: {
                    //     width: '300px'
                    // },
                    // children: (h) => {
                    //     return (
                    //         <div style="display: flex;">
                    //             <div>
                    //                 <vInputNumber required min={0} precision={4} value={this.formData.quantity} on-change={this.handleERPSKUValue}></vInputNumber>
                    //             </div>
                    //             <div class="margin-left-15">
                    //                 <span>个补货规格ERP SKU</span>
                    //             </div>
                    //         </div>
                    //     );
                    // }
                }
            ]
        }
    },
    methods: {
        async getDetail () {
            await HttpGetReplenishDetail({
                id: this.id,
            }).then(res => {
                this.formData = {
                    ...res.data
                };
                this.quantity = res.data.quantity;
                if (this.type == 'edit') {
                    HttpGetDetailByProductId({
                        id: this.formData.reProductId
                    }).then(res => {
                        this.reLineId = res.data.lineId;
                    }, err => {
                        this.$VMessage.error(err.message);
                    });
                }
            }, err => {
                this.$VMessage.error(err.message);
            });
        },
        async getLog () {
            await HttpSysOpLog({
                "search[EQ_opDataId]": this.id,
                "search[EQ_opModel]": "Product_Rule",
            }).then(res => {
                this.logList = res.data.content;
            }, err => {
                this.$VMessage.error(err.message);
            });
        },
        async submit () {
            await this.$refs.validForm.validate();
            if (!this.formData.erpSku || !this.formData.reErpSku) {
                return this.$VMessage.error("请填写ERPSKU和补货ERPSKU");
            }
            if (this.reLineId != this.formData.lineId) {
                return this.$VMessage.error("请选择相同项目的sku");
            }
            this.loading = true;
            await HttpSaveReplenishDetail({
                id: this.id,
                ...this.formData
            }).then(res => {
                this.$VMessage.success(res.message);
                this.success();
            }, err => {
                this.$VMessage.error(err.message);
            });
            this.loading = false;
        },
        success () {
            this.$emit('on-update');
            this.$emit('on-close');
        },
        cancel () {
            if (this.querytype) {
                this.$emit('on-close');
            }
            else {
                this.$router.push({
                    name: "replenishList"
                });
            }
        }
    }
}
</script>

<style>

</style>